/*
 * @Author: vinnypeng
 * @Date: 2022-04-01 20:09:49
 * @Last Modified by: vinnypeng
 * @Last Modified time: 2022-04-08 17:49:11
 */

import React, { useState, useEffect, useContext } from 'react';
import styles from './index.module.scss';
import { useRouter } from 'next/router';
import classname from 'classnames';
import { AppContext } from '@utils/browser/app-context';
import { getRedDotList, resetRedDot } from 'src/model/red-dot';

interface Props {
  children?: React.ReactChild;
  redDotPath: string;
  pagePath: string;
  before?: boolean; // 是否是在前面显示红点, 默认是后面展示
}

const RedDot = (props: Props) => {
  const { userData } = useContext(AppContext);
  const { pathname } = useRouter();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (userData?.app_id) {
      getRedDotList().then((dots) => {
        console.log('getRedDotList', dots);
        if (dots === null) return;
        console.log('redDotPath', props.redDotPath, dots[props.redDotPath]);
        if (dots[props.redDotPath]) {
          setShow(true);
          checkReset();
        } else {
          setShow(false);
        }
      });
    }
  }, [userData]);

  useEffect(() => {
    checkReset();
  }, [pathname]);

  const checkReset = () => {
    if (pathname && pathname === props.pagePath) {
      setShow(false);
      resetRedDot(props.redDotPath);
    }
  };
  return (
    <div>
      <span
        className={classname({
          [styles['red-dot-before']]: show && props.before,
          [styles['red-dot-after']]: show && !props.before,
        })}
      ></span>
      {show ? props.children : null}
    </div>
  );
};

export default RedDot;
